/**
 * Information about the markets for which consent is required can be found in the table at the link (column D):
 * https://secureservernet.sharepoint.com/:x:/r/sites/PerformanceMarketing/Shared%20Documents/06.%20Channels/Consent/GoDaddy%20Consent%20Defaults.xlsx?d=wcf13f56782404af0b26ca6f9a09adf6f&csf=1&web=1&e=NVaWYp&nav=MTJfQTE6RTMyX3sxMjBBMUVFMC0xRjZGLTlCNDQtQjFDRC02QjAzNEFGM0Y2MDB9
 */
const CONSENT_REQUIRED_MARKETS = [
  'en_GB',
  'de_CH',
  'fr_CH',
  'it_CH',
  'es_ES',
  'fi_FI',
  'fr_FR',
  'el_GR',
  'en_IE',
  'it_IT',
  'nl_NL',
  'nb_NO',
  'pt_PT',
  'sv_SE',
  'vi_VN',
  'ko_KR',
  'de_DE',
  'de_AT',
  'nl_BE',
  'fr_BE',
  'da_DK',
  'pl_PL',
  'ru_RU',
  'tr_TR',
  'en_AU',
  'ja_JP',
  'en_AE',
  'ar_AE',
  'en_IL',
  'en_MY',
  'en_NZ',
];

const SUPPORTED_MARKET_IDS = [
  'ar_AE',
  'da_DK',
  'de_AT',
  'de_CH',
  'de_DE',
  'el_GR',
  'en_AE',
  'en_AU',
  'en_CA',
  'en_GB',
  'en_HK',
  'en_IE',
  'en_IL',
  'en_IN',
  'en_MY',
  'en_NZ',
  'en_PH',
  'en_PK',
  'en_SG',
  'en_US',
  'en_ZA',
  'es_AR',
  'es_CL',
  'es_CO',
  'es_ES',
  'es_MX',
  'es_PE',
  'es_US',
  'es_VE',
  'fi_FI',
  'fr_BE',
  'fr_CA',
  'fr_CH',
  'fr_FR',
  'hi_IN',
  'id_ID',
  'it_CH',
  'it_IT',
  'ja_JP',
  'ko_KR',
  'nb_NO',
  'nl_BE',
  'nl_NL',
  'pl_PL',
  'pt_BR',
  'pt_PT',
  'qa_PS',
  'qa_PZ',
  'qa_QA',
  'ru_RU',
  'sv_SE',
  'th_TH',
  'tr_TR',
  'uk_UA',
  'vi_VN',
  'zh_HK',
  'zh_SG',
  'zh_TW',
];

module.exports = {
  CONSENT_REQUIRED_MARKETS,
  SUPPORTED_MARKET_IDS,
};
